import {
	DefaultButtonCompat as DefaultButton,
	DialogCompat as Dialog,
	DialogFooterCompat as DialogFooter,
	DialogType,
	IDialogContentProps,
	IDialogProps,
	PrimaryButtonCompat as PrimaryButton,
} from 'components/FluentUICompat';
import {useTranslation} from 'react-i18next';
import React from 'react';

export type ReadyToConfirmDialogProps = Omit<IDialogProps, 'modalProps'> & {
	onConfirm: () => void;
	requirementName: string;
};

export const ReadyToConfirmDialog: React.FC<ReadyToConfirmDialogProps> = ({
	requirementName,
	...props
}) => {
	const {t} = useTranslation('features/requirements', {
		keyPrefix: 'WorkflowDialog',
	});

	const dismiss = () => {
		props?.onDismiss?.();
	};

	const dialogContentProps: IDialogContentProps = React.useMemo(
		() => ({
			type: DialogType.normal,
			title: t('ReadyToConfirmHeader'),
			subText: t('ReadyToConfirmText', {name: requirementName}),
		}),
		[requirementName, t],
	);

	const modalProps = {
		isBlocking: true,
		styles: {main: {maxWidth: 450}},
	};

	return (
		<Dialog
			dialogContentProps={dialogContentProps}
			{...props}
			onDismiss={dismiss}
			modalProps={modalProps}
		>
			<DialogFooter>
				<PrimaryButton
					onClick={() => {
						props?.onConfirm?.();
					}}
				>
					{t('ApprovalConfirmButton')}
				</PrimaryButton>
				<DefaultButton onClick={dismiss} text={t('CancelButton')} />
			</DialogFooter>
		</Dialog>
	);
};
